import type { AppProps } from "next/app";
import { FeatureFlagsProvider } from "@/flags/flags";
import { ProductListingDataProvider } from "@/contexts/ProductListingDataContext/ProductListingDataContext";
import "../globals.scss";

export default function App({ Component, pageProps }: AppProps) {
  return (
    <FeatureFlagsProvider
      experiencesRawString={pageProps.experiencesRawString}
      flags={pageProps.flags}
      id="web-plp-scaffold-ui"
    >
      <ProductListingDataProvider
        productListingData={pageProps.productListingData}
      >
        <Component {...pageProps} />
      </ProductListingDataProvider>
    </FeatureFlagsProvider>
  );
}
